/**
 * 所有浏览器存储 key 的集中定义。
 * 新增 key 时必须在此文件注册，禁止在业务代码中硬编码字符串。
 */
export const STORAGE_KEYS = {
  locale: "pinbox.locale",
  theme: "pinbox.theme",
  colorMode: "pinbox.color-mode",
  authToken: "pinbox.auth-token",
  pluginStates: "aspect-plugin-states",
  itemLayout: "pinbox.item-layout",
  itemSort: "pinbox.item-sort",
  itemSortOrder: "pinbox.item-sort-order",
  itemPreviewLayout: "pinbox.item-preview-layout",
  itemPreviewPlacement: "pinbox.item-preview-placement",
  recentSearches: "pinbox.recent-searches",
  sidebarState: "pinbox.sidebar-state",
  sidebarWidth: "pinbox.sidebar-width",
  onboardingPendingUsers: "pinbox.onboarding.pending-users",
  exportTaskIds: "pinbox.export-task-ids",
  accountConnectIntent: "pinbox.account-connect-intent",
  pluginBgImage: "aspect-plugin-bg-image",
  pluginBgOpacity: "aspect-plugin-bg-opacity",
  pluginContentBlur: "aspect-plugin-content-blur",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
